// extracted by mini-css-extract-plugin
module.exports = {"flex":"PostCommentRejectedMessage-flex-298uA","buttonWrapper":"PostCommentRejectedMessage-buttonWrapper-1XaX6"};